module.exports = __webpack_public_path__ + "img/quick-start.22ccdac9.svg";